import { IconBookmark, IconDownload, IconInfo, IconKey, IconPhone, IconPlug, IconPower, IconShare, IconThumbUp, IconUser } from '@assets/images/icon';
import { IconCard, IconTopology } from '@assets/images/main';
import { accessAutoMain, accessLite1, accessProSchemeThumb } from '@assets/images/main/access/product';

export default {
  a: [
    { text: '기술 방식', icon: IconInfo },
    { text: '모바일 출입', icon: IconPhone },
    { text: 'NFC 출입', icon: IconCard },
    { text: '얼굴인식 출입', icon: IconUser },
    { text: '출입태그', icon: IconKey },
    { text: '출입기록 저장', icon: IconDownload },
    { text: '전원 입력', icon: IconPlug },
    { text: '서버 통신', icon: IconTopology },
    { text: '주요 사용처', icon: IconBookmark },
    { text: '추천 환경', icon: IconThumbUp },
    { text: '외부 연동', icon: IconShare },
  ],

  b: [
    { text: 'Bluetooth 5, Microwave' },
    { text: '지원' },
    { text: '미지원' },
    { text: '미지원' },
    { text: '미지원' },
    { text: '진입기록 저장' },
    { text: 'DC 12V, 24V (비극성)' },
    { text: 'Wi-Fi' },
    { text: '아파트, 기숙사, 병원 등 자동화 공간' },
    { text: '차량 위치추적, 자산 위치추적' },
    { text: '미지원' },
  ],

  c: [
    { text: 'Bluetooth 5, NFC' },
    { text: '지원' },
    { text: '지원' },
    { text: '미지원' },
    { text: '지원' },
    { text: '출입기록 저장' },
    { text: 'PoE' },
    { text: 'PoE' },
    { text: '스마트 오피스, 스튜디오, 공유시설 등' },
    { text: '차량 위치추적, 자산 위치추적' },
    { text: 'API 제공' },
  ],

  d: [
    { text: 'Bluetooth 5, NFC, AI' },
    { text: '지원' },
    { text: '지원' },
    { text: '지원' },
    { text: '지원' },
    { text: '출입기록 저장' },
    { text: '12V / 3A 어댑터' },
    { text: 'PoE, Wi-Fi' },
    { text: '고급 건물, 공동 현관, 출입통제실 등' },
    { text: '야드, 항만, 물류센터, 공사현장 등' },
    { text: 'API 제공' },
  ],

  spec: [
    {},

    {
      image: accessAutoMain,
      link: '/access/auto',
      title: 'Access Auto',
      desc: '',
    },

    {
      image: accessLite1,
      link: '/access/lite',
      title: 'Access Lite',
      desc: '',
    },

    {
      image: accessProSchemeThumb,
      link: '/access/pro',
      title: 'Access Pro',
      desc: '',
    },
  ],
};
